import api from '@/apis/di/accountCategoryAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';

// Combo grid Tài khoản nợ, có
export const useAccountCategoryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onAccountCategoryComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_category_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  // const accountComboConfig = {
  //   data: comboboxDataRemote,
  //   columns: [
  //     { title: 'Số tài khoản', dataField: 'account_number', width: 100 },
  //     { title: 'Tên tài khoản', dataField: 'account_name' }
  //   ],
  //   displayField: 'account_number',
  //   valueField: 'account_number',
  //   queryMode: 'remote',
  //   dropdownWidth: 500,
  //   comboboxLoadData: onAccountComboboxLoadData
  // };

  return {
    // accountComboConfig,
    onAccountCategoryComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
